import React, { useEffect, useState, useRef } from 'react';
import { useVirtualBackgroundContext, useInitializeCard } from 'contexts/VirtualBackgroundContext';
import { useParams } from 'react-router-dom';
import { getCardById } from 'apis/cardApi'; // Adjust the import path as needed
import { fetchVirtualBackgroundImages } from 'apis/virtualBackgroundApi'; // Ensure this import path is correct
import { NorthIcon, ColorizeOutlinedIcon } from 'icons/materialIcons';
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  IconButton,
  Checkbox,
  Grid,
  FormControlLabel,
  FormControl,
  Button
} from '@mui/material';
import { ChromePicker } from 'react-color';
import { set } from 'react-hook-form';
import VirtualBackgroundCustomLogo from './VirtualBackgroundCustomLogo';

import UploadImage from './UploadImage';

const VirtualBackgroundContainer = () => {
  const [selectedButton, setSelectedButton] = useState('library'); // 'library' button selected by default

  const [refreshKey, setRefreshKey] = useState(0);

  const { cardId } = useParams();
  const [loading, setLoading] = useState(true);
  const [cardDetails, setCardDetails] = useState({});
  const colorOptions = ['#000000', '#eb5757', '#f2994b', '#f2c84b', '#219654', '#2f82ed', '#9b51e0'];
  const [showQRCodeColorPicker, setShowQRCodeColorPicker] = useState(false);
  const cardPickerRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [imagesPerPage] = useState(12); // 3 columns x 4 rows






  const [qrCodeColor, setQrCodeColor] = useState('#000000'); // Local state for QR code color
  const [images, setImages] = useState([]); // State to hold virtual background images

  // In VirtualBackgroundContainer.js, add these with your other state declarations
  const [uploadedImage, setUploadedImage] = useState(null);
  const [showCropper, setShowCropper] = useState(false);



  useInitializeCard(cardId); // Ensure initialization happens before accessing values



  const handleCancel = () => {
    if (cardId) {
      setVirtualBackgroundContextQRCodeColor(cardId, '#000000');
      setVirtualBackgroundContextQRCodeLogoUrl(cardId, null); // Add this line
      // Reset other settings as needed
      setRefreshKey(prev => prev + 1);
    }
  };


  // Fetch card details
  useEffect(() => {
    const fetchCardDetails = async () => {
      try {
        console.log("card id from virtual card container", cardId);
        const data = await getCardById(cardId);
        console.log('Card details:', data);
        setCardDetails(data);
      } catch (error) {
        console.error('Error fetching card details:', error);
      } finally {
        setLoading(false);
      }
    };

    if (cardId) {
      fetchCardDetails();
    }
  }, [cardId]);





  const {
    setVirtualBackgroundContextCardName,
    setVirtualBackgroundContextCompany,
    setVirtualBackgroundContextJobTitle,
    setVirtualBackgroundContextLocation,
    setVirtualBackgroundContextQRCodeColor,
    setVirtualBackgroundContextShowQRCode,
    setVirtualBackgroundContextCondensedView,
    setVirtualBackgroundContextQRCodeLogoUrl,
    setVirtualBackgroundContextBackgroundImageUrl,
    setVirtualBackgroundContextShowCardName,
    setVirtualBackgroundContextShowCompany,
    setVirtualBackgroundContextShowJobTitle,
    setVirtualBackgroundContextShowLocation,
    backgroundCardState,

  } = useVirtualBackgroundContext();

  const {
    virtualBackgroundContextCondensedView,
    virtualBackgroundContextShowCardName,
    virtualBackgroundContextShowCompany,
    virtualBackgroundContextShowJobTitle,
    virtualBackgroundContextShowLocation,
    virtualBackgroundContextShowQRCode,
    virtualBackgroundContextCardName,
    virtualBackgroundContextCompany,
    virtualBackgroundContextJobTitle,
    virtualBackgroundContextLocation,
    virtualBackgroundContextBackgroundImageUrl // Destructure showQRCode state
  } = backgroundCardState;




  useEffect(() => {
    if (cardDetails?.card) { // Ensure cardDetails.card exists
      console.log('Populating context with card details:', cardDetails); // Log when updating context
      const cardName = cardDetails.card.contact_info?.fullName || '';
      const jobTitle = cardDetails.card.contact_info?.jobTitle || '';
      const company = cardDetails.card.contact_info?.company || '';
      const location = cardDetails.card.contact_info?.location || '';

      if (backgroundCardState[cardId]?.virtualBackgroundContextCardName !== cardName) {
        setVirtualBackgroundContextCardName(cardId, cardName);
      }

      if (backgroundCardState[cardId]?.virtualBackgroundContextJobTitle !== jobTitle) {
        setVirtualBackgroundContextJobTitle(cardId, jobTitle);
      }

      if (backgroundCardState[cardId]?.virtualBackgroundContextCompany !== company) {
        setVirtualBackgroundContextCompany(cardId, company);
      }

      if (backgroundCardState[cardId]?.virtualBackgroundContextLocation !== location) {
        setVirtualBackgroundContextLocation(cardId, location);
      }
    }
  }, [cardDetails,
    cardId,
    setVirtualBackgroundContextCardName,
    setVirtualBackgroundContextJobTitle,
    setVirtualBackgroundContextCompany,
    setVirtualBackgroundContextLocation,
    backgroundCardState]);




  console.log('Current card name from demo2:', backgroundCardState[cardId]?.virtualBackgroundContextCardName);
  console.log('Current job title from demo2:', backgroundCardState[cardId]?.virtualBackgroundContextJobTitle);
  console.log('Current company from demo2:', backgroundCardState[cardId]?.virtualBackgroundContextCompany);
  console.log('Current location from demo2:', backgroundCardState[cardId]?.virtualBackgroundContextLocation);




  // Add this new useEffect after your existing fetch images useEffect
  // Add this useEffect after your image fetch useEffect
  useEffect(() => {
    if (images.length > 0 && cardId && backgroundCardState && !backgroundCardState[cardId]?.virtualBackgroundContextBackgroundImageUrl) {
      console.log('Setting initial background image:', images[0].webformatURL);
      setVirtualBackgroundContextBackgroundImageUrl(cardId, images[0].webformatURL);
    }
  }, [images, cardId, backgroundCardState, setVirtualBackgroundContextBackgroundImageUrl]);

  const handleImageClick = (url) => {

    setVirtualBackgroundContextBackgroundImageUrl(cardId, url); // Set context with selected image URL
  };





  useEffect(() => {
    const imageUrl = backgroundCardState[cardId]?.virtualBackgroundContextBackgroundImageUrl;

    if (imageUrl) {
      console.log("Image URL set to context from useEffect:", imageUrl); // Log when the URL is set

      // Create a new Image object to load the image and get its size
      const img = new Image();
      img.src = imageUrl;

      img.onload = () => {
        console.log(`Image dimensions: ${img.width} x ${img.height}`); // Log the dimensions when the image loads
      };

      img.onerror = (error) => {
        console.error("Error loading image:", error); // Log an error if the image fails to load
      };
    }
  }, [backgroundCardState[cardId]?.virtualBackgroundContextBackgroundImageUrl]);



  useEffect(() => {
    setVirtualBackgroundContextCondensedView(cardId, backgroundCardState[cardId]?.virtualBackgroundContextCondensedView ?? false); // Update context when condensedView changes
  }, [backgroundCardState[cardId]?.virtualBackgroundContextCondensedView]);

  // Handle outside clicks to close the color picker
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cardPickerRef.current && !cardPickerRef.current.contains(event.target)) {
        setShowQRCodeColorPicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);




  const handleQRCodeColorPickertoggle = () => {
    setShowQRCodeColorPicker((prev) => !prev);
  };

  const handleQRCodeColorChangeComplete = (color) => {
    setQrCodeColor(color.hex);
    setVirtualBackgroundContextQRCodeColor(cardId, color.hex);
  };

  // Update QR code color in the context
  useEffect(() => {
    // Only update if the new color is different from the current context color
    const currentColor = backgroundCardState[cardId]?.virtualBackgroundContextQRCodeColor;

    if (currentColor !== qrCodeColor) {
      setVirtualBackgroundContextQRCodeColor(cardId, qrCodeColor);
    }
  }, [qrCodeColor, backgroundCardState, cardId]); // Only watch qrCodeColor and necessary context state


  // Fetch virtual background images
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const fetchedImages = await fetchVirtualBackgroundImages(); // Example function to fetch images
        setImages(fetchedImages);
      } catch (error) {
        console.error('Error fetching virtual background images:', error);
      }
    };

    fetchImages();
  }, []); // Only fetch images once when the component mounts

  // Pagination logic
  const indexOfLastImage = currentPage * imagesPerPage;
  const indexOfFirstImage = indexOfLastImage - imagesPerPage;
  const currentImages = images.slice(indexOfFirstImage, indexOfLastImage);

  const nextPage = () => {
    if (currentPage < Math.ceil(images.length / imagesPerPage)) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };




  return (
    <Container maxWidth="sm">
      <Box my={4}>
        <Typography variant="body2" sx={{ fontSize: '1.1rem', fontWeight: 600, color: '#4f4f4f', marginBottom: '10px' }} gutterBottom align="left">
          Virtual background
        </Typography>
        {loading ? (
          <CircularProgress />
        ) : (
          <Box sx={{ marginTop: 5 }}>
            {/* QR Code Color Picker */}
            <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 600, color: '#4f4f4f', marginBottom: '13px' }}>
              Choose QR color
            </Typography>
            <Box
              sx={{
                marginBottom: 2,
                width: '60%',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexGrow: 1,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <IconButton
                  onClick={handleQRCodeColorPickertoggle}
                  sx={{
                    position: 'relative',
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      borderRadius: '50%',
                      border: `2px solid ${qrCodeColor}`,
                    }}
                  />
                  <ColorizeOutlinedIcon sx={{ color: '#828282', fontSize: 16 }} />
                </IconButton>

                {colorOptions.map((color, index) => (
                  <Box
                    key={index}
                    onClick={() => handleQRCodeColorChangeComplete({ hex: color })}
                    sx={{
                      width: 24,
                      height: 24,
                      position: 'relative',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        position: 'absolute',
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        border: `2px solid ${qrCodeColor === color ? '#dbdbdb' : '#ffffff'}`,
                      }}
                    />
                    <Box
                      sx={{
                        width: '85%',
                        height: '85%',
                        borderRadius: '50%',
                        backgroundColor: color,
                      }}
                    />
                  </Box>
                ))}

                {showQRCodeColorPicker && (
                  <Box sx={{ position: 'absolute', top: '40px', right: 0, zIndex: 2 }} ref={cardPickerRef}>
                    <ChromePicker color={qrCodeColor} onChange={handleQRCodeColorChangeComplete} disableAlpha />
                  </Box>
                )}
              </Box>
            </Box>


            {/* QR Code Logo Component*/}
            <Box sx={{ marginTop: 4 }}>
              <VirtualBackgroundCustomLogo
                key={`logo-${refreshKey}`}
                forceReset={refreshKey}
              />
            </Box>


            {/* Checkboxes Container */}
            <Box sx={{ marginTop: 4 }}>
              <FormControl component="fieldset" variant="standard">
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={backgroundCardState[cardId]?.virtualBackgroundContextCondensedView}
                          onChange={(event) => setVirtualBackgroundContextCondensedView(cardId, event.target.checked)} // Directly update with the new value
                          color="dark"
                        />
                      }
                      label={
                        <Box>
                          <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 600, color: "#4f4f4f" }}>
                            Condensed View
                          </Typography>
                          <Typography variant="body2" sx={{ fontSize: '0.8rem', color: '#828282' }}>
                            Optimal for Microsoft Teams
                          </Typography>
                        </Box>
                      }
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={backgroundCardState[cardId]?.virtualBackgroundContextShowQRCode}
                          onChange={(event) => setVirtualBackgroundContextShowQRCode(cardId, event.target.checked)}
                          color="dark"
                        />
                      }
                      label={
                        <Box>
                          <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 600, color: "#4f4f4f" }}>

                            QR Code                          </Typography>
                          <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500, color: '#828282' }}>
                            QR Code can be customized in the QR Code section
                          </Typography>
                        </Box>
                      }
                    />
                  </Grid>

                  {/* Name and Company Checkboxes in Row */}
                  <Grid container item spacing={1}>
                    <Grid item xs={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={backgroundCardState[cardId]?.virtualBackgroundContextShowCardName}
                            onChange={(event) => setVirtualBackgroundContextShowCardName(cardId, event.target.checked)}
                            color="dark"
                          />
                        }
                        label={
                          <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 600, color: "#4f4f4f" }}>
                            Name
                          </Typography>
                        }

                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={backgroundCardState[cardId]?.virtualBackgroundContextShowCompany}
                            onChange={(event) => setVirtualBackgroundContextShowCompany(cardId, event.target.checked)}
                            color="dark"
                          />
                        }
                        label={
                          <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 600, color: "#4f4f4f" }}>
                            Company
                          </Typography>
                        }
                      />
                    </Grid>

                    {/* Job Title and Location Checkboxes in Row */}
                    <Grid item xs={6}>
                      <FormControlLabel

                        control={
                          <Checkbox
                            checked={backgroundCardState[cardId]?.virtualBackgroundContextShowJobTitle}
                            onChange={(event) => setVirtualBackgroundContextShowJobTitle(cardId, event.target.checked)}
                            color="dark"
                          />
                        }
                        label={
                          <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 600, color: "#4f4f4f" }}>
                            Job Title
                          </Typography>
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={backgroundCardState[cardId]?.virtualBackgroundContextShowLocation}
                            onChange={(event) => setVirtualBackgroundContextShowLocation(cardId, event.target.checked)}
                            color="dark"
                          />
                        }
                        label={
                          <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 600, color: "#4f4f4f" }}>
                            Location
                          </Typography>
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </FormControl>
            </Box>

            {/* New Container with Background Color */}


            <Box sx={{ backgroundColor: '#f7f7f7', padding: '8px', borderRadius: '8px', marginTop: 4 }}>
              <Box display="flex" gap={1}>
                <Button
                  variant="text"
                  onClick={() => {
                    setSelectedButton('library');
                  }}
                  sx={{
                    flexGrow: 1,
                    borderRadius: '8px',
                    backgroundColor: selectedButton === 'library' ? 'white' : 'transparent',
                    '&:hover': {
                      backgroundColor: 'white',
                    },
                    '&:active': {
                      backgroundColor: 'white', // Keeps the background white when clicked
                    },
                    '&:focus': {
                      outline: 'none',
                      backgroundColor: 'white', // Keeps the background white when focused
                    },
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    color: "#4f4f4f",
                    textTransform: 'none', // Prevents text from being in uppercase
                  }}
                >
                  Choose from Library
                </Button>

                <Button
                  variant="text"
                  onClick={() => {

                    setSelectedButton('upload');
                  }}
                  sx={{
                    flexGrow: 1,
                    borderRadius: '8px',
                    backgroundColor: selectedButton === 'upload' ? 'white' : 'transparent',
                    '&:hover': {
                      backgroundColor: 'white',
                    },
                    '&:active': {
                      backgroundColor: 'white', // Keeps the background white when clicked
                    },
                    '&:focus': {
                      outline: 'none',
                      backgroundColor: 'white', // Keeps the background white when focused
                    },
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    color: "#4f4f4f",
                    textTransform: 'none', // Prevents text from being in uppercase
                  }}
                >
                  Upload Image
                </Button>
              </Box>








            </Box>
            {/* ... */}

            {selectedButton === 'library' && (
              <>
                {/* Image Grid Display */}
                <Grid container spacing={2} alignItems="center" justifyContent="center" sx={{ marginTop: "2px" }}>
                  {currentImages.map((image, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={4} key={index}> {/* Responsive grid */}
                      <Box
                        sx={{
                          width: '100%',
                          height: 0,
                          paddingBottom: '75%', // 4:3 aspect ratio
                          position: 'relative',
                          borderRadius: 3, // Increased border radius for more rounded corners
                          border: backgroundCardState[cardId]?.virtualBackgroundContextBackgroundImageUrl === image.webformatURL ? '4px solid #2fabed' : 'none',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleImageClick(image.webformatURL)}
                      >
                        <img
                          src={image.webformatURL}
                          alt={image.tags}
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: 8, // Increased border radius for more rounded corners
                          }}
                        />
                      </Box>
                    </Grid>
                  ))}
                </Grid>

                {/* Pagination Buttons */}
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, marginTop: 5 }}>
                  <Button
                    variant="outlined"
                    onClick={prevPage}
                    disabled={currentPage === 1}
                    startIcon={<NorthIcon sx={{ transform: 'rotate(-90deg)' }} />}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: '0.8rem',
                      fontWeight: 600,
                      color: '#4f4f4f',
                      textTransform: 'none',
                      padding: '6px 28px',
                      borderRadius: '18px',
                      borderColor: currentPage === 1 ? '#e0e0e0' : '#dfdfdf',
                    }}
                  >
                    Prev
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={nextPage}
                    disabled={currentPage >= Math.ceil(images.length / imagesPerPage)}
                    endIcon={<NorthIcon sx={{ transform: 'rotate(90deg)' }} />}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: '0.8rem',
                      fontWeight: 600,
                      color: '#4f4f4f',
                      borderRadius: '18px',
                      padding: '6px 28px',

                      textTransform: 'none',
                      borderColor: currentPage >= Math.ceil(images.length / imagesPerPage) ? '#e0e0e0' : '#dfdfdf',
                    }}
                  >
                    Next
                  </Button>
                </Box>


              </>
            )}

            {/* ... */}


            {selectedButton === 'upload' && (
              <UploadImage onImageSelect={(croppedImageUrl) => {
                setVirtualBackgroundContextBackgroundImageUrl(cardId, croppedImageUrl);
              }} />
            )}
          </Box>




        )}
      </Box>
    </Container>
  );
};

export default VirtualBackgroundContainer;

